class ShareTable {
  showsMore;
  table;
  button;
  constructor() {
    this.showsMore = false;
    this.table = $('.sharetable#extra-stock-table-container')
    this.button = $('button#extra-stock-table-toggle-btn')
    window.bones_toggle_table = this.toggle_table
  }

  toggle_table = () => {
    this.table.toggleClass("expanded")
    this.showsMore = !this.showsMore
    this.button.text((this.showsMore ? 
      "SHOW LESS" : "SHOW MORE"  
    ))
  }

}

window.ShareTable = ShareTable;
